import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const FALLBACK_TIME_ZONE = 'UTC';

dayjs.extend(utc);
dayjs.extend(timezone);

function isSupportedTimeZone(timeZone) {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone }).format(new Date(0));
    return true;
  } catch {
    return false;
  }
}

export function getClientTimeZone() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const normalized = String(timeZone || '').trim();

    return normalized || FALLBACK_TIME_ZONE;
  } catch {
    return FALLBACK_TIME_ZONE;
  }
}

export function resolveClientTimeZone(value) {
  const explicitTimeZone = String(value ?? '').trim();

  return explicitTimeZone && isSupportedTimeZone(explicitTimeZone)
    ? explicitTimeZone
    : getClientTimeZone();
}

export function formatZonedDayBoundary(dateValue, boundary, timeZone) {
  const dateKey = String(dateValue ?? '').trim().match(/^(\d{4}-\d{2}-\d{2})/)?.[1];

  if (!dateKey) {
    return '';
  }

  const resolvedTimeZone = resolveClientTimeZone(timeZone);
  const isEndBoundary = boundary === 'end';

  try {
    const zonedDate = dayjs.tz(dateKey, resolvedTimeZone);

    if (!zonedDate.isValid()) {
      return '';
    }

    const boundaryDate = isEndBoundary
      ? zonedDate.endOf('day')
      : zonedDate.startOf('day');
    const microseconds = isEndBoundary ? '999999' : '000000';

    return `${boundaryDate.format('YYYY-MM-DDTHH:mm:ss')}.${microseconds}${boundaryDate.format('Z')}`;
  } catch {
    return '';
  }
}
